export const DEFAULT_CARD_BG_COLOR = "#524f5a";
export const QR_CODE_URL = "https://tappoints.es";